<template>
  <div id="sovdetail">
    <div data-html2canvas-ignore="true" class="customdim" v-show="loader">
      <div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>
    </div>
  	<div class="datepickerwrap">
  		<div class="leftcontent wrapitem">
  			<div class="datebox">
  	 			<datepicker placeholder="From" @input="changeCustomDate" v-model="date.startDate" />
  	 		</div>
  	 		<div class="datebox">
          <select v-model="selected_website" class="form-control text-uppercase">
          	<option value="https://www.amazon.com">Amazon</option>
          </select>
        </div>
        <div class="datebox" style="width:18%">
          <select  class="form-control text-uppercase">
            <option>breakfast cereal</option>
          </select>
        </div>
  	 		<div class="datebox">
          <button @click="refresh" class="btn btn-block weavrpurple" type="button">
            <span style="font-size:13px">Submit</span>
          </button>
        </div>
  	 	</div>
       <div class="righcontent wrapitem">
        	<div class="datebox" style="float:right">
          <button @click="backToSov" style="width:max-content;float:right" class="btn btn-block weavrpurple" type="button">
            <i class="fa fa-arrow-left"></i>
            <span style="font-size:13px"> Back</span>
          </button>
        </div>
      </div>
  	</div>
    <div class="container-fluid ">
      <div class="">
        <div class="card p-2">
          <div class="amd-legend"> 
          
            <div class="legending">
              <i class="fa fa-circle" style="color: #ffb9b9!important"></i>
              <span>nesplus</span>
            </div>  
            <div class="legending">
              <i class="fa fa-circle" style="color: #c7e0ff!important"></i>
              <span>kelloggs</span>
            </div>  
            <div class="legending">
              <i class="fa fa-circle" style="color: #ffd0f5 !important"></i>
              <span>yogabar</span>
            </div>  
          </div>  
          <table id="myTable2" class="table table-striped table-bordered">
            <thead class="thead-normal">
              <tr>
                <th v-for="d in columns_details" :key="d.field"> {{ d.label  }} </th>
              </tr>
            </thead>
            <tfoot style="display: table-row-group;">
                <tr>
                  <th v-for="d in columns_details" :key="d.field"> {{ d.label  }} </th>
                </tr>
              </tfoot> 
            <tbody class="tbody-normal" > 
              <tr v-for="(r,i) in rows_details"  :key="i" :class="{'markitamd':r['brand'] == 'nesplus',
                'markitintel':r['brand'] == 'kellogg\'s','markitsnap':r['brand'] == 'yogabar'}">
                <td v-for="d in columns_details" :key="d.field" > 
                  <span v-if="d.field == 'product_name'">
                    <a target="_blank" :href="r['link']">{{r[d.field]}}</a>
                  </span>
                  <span v-else>
                    <span v-if="r[d.field] != ''">
                      <span>{{r[d.field]}}</span>
                    </span>
                    <span v-else>-</span>  
                  </span>
                </td>
              </tr>
            </tbody>
          </table> 
        </div>   
      </div>  
    </div>  
    <b-modal size="lg" title="Audit" v-model="showAuditModal" >
      <table id="sku" class="table table-bordered">
        <thead class="thead-normal">
          <tr>
            <th v-for="d in columnsAudit" :key="d.field" style="border:1px solid silver!important"> 
               {{ d.label  }} 
              <span  v-if="d.field == 'compliance_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(((Product Logo + OEM Images + Nomenclature + Message)/4)/3)*100">?</b-btn> 
              </span>   
              <span  v-if="d.field == 'position_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(100 - Category Position) 
                  if Category Position < 100,
                  0 if Category Position > 100">?</b-btn> 
              </span>  
              <span  v-if="d.field == 'sku_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(Compliance Score + Position Score + Rating Score)/3">?</b-btn> 
              </span>  
              <span  v-if="d.field == 'rating_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(Rating/5)*100">?</b-btn> 
              </span>  
            </th>
          </tr>
        </thead>
        <tbody class="tbody-normal" > 
          <tr v-for="(r,i) in rowsAudit" :key="i">
            <td v-for="d in columnsAudit" :key="d.field" style="border:1px solid silver!important"> 
              {{r[d.field]}} 
            </td>
          </tr>
        </tbody>
      </table>   
      <h5 class="cust-head">Position Score</h5>
      <table id="position" class="table table-bordered">
      <thead class="thead-normal">
        <tr>
          <th v-for="d in columns_category" :key="d.field" style="border:1px solid silver!important"> 
            {{ d.label  }}
            <span  v-if="d.field == 'category_position'">
                <b-btn class="hint" v-b-tooltip.hover title="Position In Category Page">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'category_13_position'">
                <b-btn class="hint" v-b-tooltip.hover title="1: If System in page 1 of results
                  2: if System in page 2-3 of results
                  3: if System not in pages 1-3 ">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'search_position'">
                <b-btn class="hint" v-b-tooltip.hover title="Position in on-site search">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'search_13_position'">
                <b-btn class="hint" v-b-tooltip.hover title="1: If System in page 1 of search results
                  2: if System in page 2-3 of search results
                  3: if System not in pages 1-3 ">?</b-btn> 
            </span> 
          </th>
        </tr>
      </thead>
      <tbody class="tbody-normal" > 
        <tr v-for="(r,i) in rowsAudit" :key="i">
          <td v-for="d in columns_category" :key="d.field" style="border:1px solid silver!important"> 
            <span> {{r[d.field]}} </span>
          </td>
        </tr>
      </tbody>
      </table> 

      <h5 class="cust-head">Compliance Score</h5>
      <table id="compliance" class="table table-bordered">
      <thead class="thead-normal">
        <tr>
          <th v-for="d in columns_compliance" :key="d.field" style="border:1px solid silver!important"> 
            {{ d.label  }} 
            <span  v-if="d.field == 'logo'">
                <b-btn class="hint" v-b-tooltip.hover title="1: Correct AMD Badges
                  2: Incorrect AMD Badges
                  3: No AMD Badges">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'image_count'">
                <b-btn class="hint" v-b-tooltip.hover title="1: 3 or more product images
                  2: 2 more product images
                  3: 0 or 1 product images">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'nomenclature'">
                <b-btn class="hint" v-b-tooltip.hover title="1: Correct AMD Nomenclature
                  2: Incorrect AMD Nomenclature
                  3: No AMD Nomenclature">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'message'">
                <b-btn class="hint" v-b-tooltip.hover title="1: Correct AMD Messaging
                  2: Incorrect AMD Messaging
                  3: No AMD Messaging">?</b-btn> 
            </span> 
          </th>
        </tr>
      </thead>
      <tbody class="tbody-normal" > 
        <tr v-for="(r,i) in rowsAudit" :key="i">
          <td v-for="d in columns_compliance" :key="d.field" style="border:1px solid silver!important"> 
            <span> {{r[d.field]}} </span>
          </td>
        </tr>
      </tbody>
      </table> 
    </b-modal>
  </div>
</template>
<script>  

import moment from 'moment'
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'sovdetail',
  components: { Datepicker},
  data: function () {
    return {
    	selected_website:localStorage.selected_website,
      date:{
        startDate: moment().subtract(1,'days').format('YYYY-MM-DD')
      },
      columns_details:[
        {label: 'Rank', field: 'order'},
        {label: 'Page', field: 'page'},
        {label: 'Brand', field: 'brand'},
        {label: 'Name', field: 'product_name',sortable: false},
        {label: 'Price', field: 'price',sortable: false},
        {label: 'Offer', field: 'offer',sortable: false},
        {label: 'Reviews', field: 'reviews'},
        {label: 'Ratings', field: 'ratings'}
      ],
      rows:[],
      rows_details:[],
      page:1,   
      showAuditModal: false,
      columnsAudit:[
        {label: 'SKU', field: 'sku', sortable: false},
        {label: 'Compliance Score', field:'compliance_score', sortable: false},
        {label: 'Position Score', field: 'position_score', sortable: false},
        {label: 'Rating Score', field: 'rating_score', sortable: false},
        {label: 'SKU Score', field: 'sku_score', sortable: false},
      ],
      columns_category:[
        {label: 'Category Position', field: 'category_position',sortable: false},
        {label: 'Category page position (1-3)', field: 'category_13_position',sortable: false},
        {label: 'Search Position', field: 'search_position',sortable: false},
        {label: 'Search (1-3) Position', field: 'search_13_position',sortable: false}
      ],
      columns_compliance:[
        {label: 'Product Logo', field: 'logo',sortable: false},
        {label: 'OEM Images', field: 'image_count',sortable: false},
        {label: 'Nomenclature', field: 'nomenclature',sortable: false},
        {label: 'Message', field: 'message',sortable: false}
      ],
      rowsAudit: [],
      isHero: false,
      rows_details_full: [],
      loader: false
    }
  },
  mounted()
  {
    this.website_details()
  },
  methods: {
    backToSov()
    { 
      window.location = '#/sov-summary-nesplus'

    },
    showHeroChange(){
      let self = this
      $('#myTable2').DataTable().destroy();
      this.rows_details = []
      for(let [idx, dataset] of this.rows_details_full.entries()) 
      {
        if(self.isHero)
        {
          if(dataset.is_hero)
          {
            this.rows_details.push(dataset)
          }  
        }  
        else
          this.rows_details.push(dataset)
      }
      this.$nextTick(function(){
        self.initDt2()
      })  
    },
   
    openAuditModal(r){
      let self = this
      self.rowsAudit = []
      self.showAuditModal = true
      self.rowsAudit.push(r.audit)
    },
    
    format(v)
    {
      return this.$options.filters.format(v)
    },
    refresh(){
      $('#myTable2').DataTable().destroy();
      localStorage.selected_website = this.selected_website
      this.website_details()
    },
  
    website_details(){
      let self = this
      self.loader = true
      this.rows_details = []
      this.rows_details_full = []
      const url = "/api/websites/details"
      this.$http.post(url, { "website": this.selected_website,"timestamp":this.date.startDate }).then(response => {
        let resData = [
  {
    "order": 1,
    "price": "Rs 394.00",
    "offer": "Rs 425.00",
    "page": 1,
    "link": "https://www.amazon.in//Kelloggs-Corn-Flakes-Original-1-2/dp/B07X675VSL/",
    "page_count": 48,
    "reviews": 545,
    "ratings": 4.4,
    "image_count": 7,
    "product_name": "Kellogg's Corn Flakes Original, 1.2 kg",
    "item_id": "B07X675VSL",
    "brand": "kellogg's",
    "client": "test"
  },
  {
    "order": 2,
    "price": null,
    "offer": "Rs 310.00",
    "page": 1,
    "link": "https://www.amazon.in//Solimo-Amazon-Brand-Corn-Flakes/dp/B083NZQ4B3/",
    "page_count": 48,
    "reviews": 64,
    "ratings": 4.2,
    "image_count": 7,
    "product_name": "Amazon Brand - Solimo Corn Flakes 875g",
    "item_id": "B083NZQ4B3",
    "brand": "amazon brand - solimo",
    "client": "test"
  },
  {
    "order": 3,
    "price": "Rs 489.00",
    "offer": "Rs 550.00",
    "page": 1,
    "link": "https://www.amazon.in//Kelloggs-Real-Almond-Honey-Flakes/dp/B01H5LBWG2/",
    "page_count": 48,
    "reviews": 450,
    "ratings": 4.5,
    "image_count": 6,
    "product_name": "Kellogg's Corn Flakes Real Almond and Honey, 1 kg",
    "item_id": "B01H5LBWG2",
    "brand": "kellogg's",
    "client": "test"
  },
  {
    "order": 4,
    "price": "Rs 180.00",
    "offer": null,
    "page": 1,
    "link": "https://www.amazon.in//Kelloggs-Corn-Flakes-475g/dp/B00TIMOXFO/",
    "page_count": 48,
    "reviews": 1483,
    "ratings": 4.4,
    "image_count": 6,
    "product_name": "Kellogg's Corn Flakes Original, 475g",
    "item_id": "B00TIMOXFO",
    "brand": "kellogg's",
    "client": "test"
  },
  {
    "order": 5,
    "price": null,
    "offer": "Rs 295.00",
    "page": 1,
    "link": "https://www.amazon.in//Healthy-Balance-Corn-Flakes-875gm/dp/B07S3VKN58/",
    "page_count": 48,
    "reviews": 300,
    "ratings": 4.2,
    "image_count": 7,
    "product_name": "Healthy Balance Corn Flakes 875gm",
    "item_id": "B07S3VKN58",
    "brand": "healthy balance",
    "client": "test"
  },
  {
    "order": 6,
    "price": "Rs 512.00",
    "offer": "Rs 520.00",
    "page": 1,
    "link": "https://www.amazon.in//Kelloggs-Real-Almond-Honey-Flakes/dp/B01D10FPNC/",
    "page_count": 48,
    "reviews": 743,
    "ratings": 4.4,
    "image_count": 6,
    "product_name": "Kellogg's Corn Flakes Real Almond and Honey, 1 kg",
    "item_id": "B01D10FPNC",
    "brand": "kellogg's",
    "client": "test"
  },
  {
    "order": 7,
    "price": "Rs 166.00",
    "offer": "Rs 180.00",
    "page": 1,
    "link": "https://www.amazon.in//Kelloggs-Corn-Flakes-475g/dp/B01H6Q0NK2/",
    "page_count": 48,
    "reviews": 909,
    "ratings": 4.5,
    "image_count": 6,
    "product_name": "Kellogg's Corn Flakes, 475g",
    "item_id": "B01H6Q0NK2",
    "brand": "kellogg's",
    "client": "test"
  },
  {
    "order": 8,
    "price": "Rs 251.00",
    "offer": "Rs 265.00",
    "page": 1,
    "link": "https://www.amazon.in//Kelloggs-Cornflakes-Real-Strawberry-Puree/dp/B01H6Q0RUS/",
    "page_count": 48,
    "reviews": 73,
    "ratings": 4.4,
    "image_count": 6,
    "product_name": "Kellogg's Cornflakes with Real Strawberry Puree, 575g",
    "item_id": "B01H6Q0RUS",
    "brand": "kellogg's",
    "client": "test"
  },
  {
    "order": 9,
    "price": "Rs 162.00",
    "offer": "Rs 180.00",
    "page": 1,
    "link": "https://www.amazon.in//Nestl%C3%A9-NesPlus-Breakfast-Cereal-Crunchy/dp/B0845GW9WM/",
    "page_count": 48,
    "reviews": 188,
    "ratings": 4.4,
    "image_count": 7,
    "product_name": "Nestle NesPlus Breakfast Cereal - Crunchy Flakes with Corn & Oats, 475g Carton",
    "item_id": "B0845GW9WM",
    "brand": "nesplus",
    "client": "test"
  },
  {
    "order": 10,
    "price": "Rs 269.00",
    "offer": "Rs 290.00",
    "page": 1,
    "link": "https://www.amazon.in//Kelloggs-Corn-Flakes-Honey-630g/dp/B01H6QFNCK/",
    "page_count": 48,
    "reviews": 59,
    "ratings": 4.5,
    "image_count": 6,
    "product_name": "Kellogg’s Corn Flakes with Real Honey | Breakfast Cereals | Low Fat | High in Vitamin C | High in Iron | Naturally Cholesterol Free | 630g Pack",
    "item_id": "B01H6QFNCK",
    "brand": "kellogg's",
    "client": "test"
  },
  {
    "order": 11,
    "price": null,
    "offer": "Rs 500.00",
    "page": 1,
    "link": "https://www.amazon.in//Solimo-Amazon-Brand-Chocos-1200/dp/B0842C6QJ8/",
    "page_count": 48,
    "reviews": 147,
    "ratings": 4.2,
    "image_count": 7,
    "product_name": "Amazon Brand - Solimo Choco Flakes, 1.2kg",
    "item_id": "B0842C6QJ8",
    "brand": "amazon brand - solimo",
    "client": "test"
  },
  {
    "order": 12,
    "price": "Rs 315.00",
    "offer": null,
    "page": 1,
    "link": "https://www.amazon.in//Kelloggs-Crunchy-Granola-Almonds-Cranberries/dp/B07DJGCKLM/",
    "page_count": 48,
    "reviews": 776,
    "ratings": 4.5,
    "image_count": 7,
    "product_name": "Kellogg's Crunchy Granola Almonds and Cranberries 460g",
    "item_id": "B07DJGCKLM",
    "brand": "kellogg's",
    "client": "test"
  },
  {
    "order": 13,
    "price": "Rs 175.00",
    "offer": null,
    "page": 1,
    "link": "https://www.amazon.in//8AM-Gluten-Free-Cornflakes/dp/B08LDN8HLM/",
    "page_count": 48,
    "reviews": 1,
    "ratings": 5,
    "image_count": 6,
    "product_name": "8AM Gluten Free Cornflakes",
    "item_id": "B08LDN8HLM",
    "brand": "8am",
    "client": "test"
  },
  {
    "order": 14,
    "price": "Rs 280.00",
    "offer": "Rs 330.00",
    "page": 1,
    "link": "https://www.amazon.in//Bagrrys-Corn-Flakes-800g-Extra/dp/B071S6LMBH/",
    "page_count": 48,
    "reviews": 701,
    "ratings": 4.2,
    "image_count": 7,
    "product_name": "Bagrrys Corn Flakes, 800g (with Extra 80g)",
    "item_id": "B071S6LMBH",
    "brand": "bagrry's",
    "client": "test"
  },
  {
    "order": 15,
    "price": "Rs 290.00",
    "offer": null,
    "page": 1,
    "link": "https://www.amazon.in//Kelloggs-Corn-Flakes-Honey-630g/dp/B00TZIHKB0/",
    "page_count": 48,
    "reviews": 100,
    "ratings": 4.3,
    "image_count": 6,
    "product_name": "Kellogg's Corn Flakes with Honey, 630g",
    "item_id": "B00TZIHKB0",
    "brand": "kellogg's",
    "client": "test"
  },
  {
    "order": 16,
    "price": "Rs 240.00",
    "offer": null,
    "page": 1,
    "link": "https://www.amazon.in//Corn-Flakes-Family-Pack-1kg/dp/B08P5LTC7D/",
    "page_count": 48,
    "reviews": 0,
    "ratings": 0,
    "image_count": 6,
    "product_name": "Corn Flakes Family Pack(1kg)",
    "item_id": "B08P5LTC7D",
    "brand": "8am",
    "client": "test"
  },
  {
    "order": 17,
    "price": "Rs 190.00",
    "offer": "Rs 380.00",
    "page": 1,
    "link": "https://www.amazon.in//Dr-Gluten-Flakes-Original-400gram/dp/B089WD97C2/",
    "page_count": 48,
    "reviews": 8,
    "ratings": 3.8,
    "image_count": 7,
    "product_name": "Dr. Gluten Power Flakes, Original Corn Flakes, Gluten Free, 400gram",
    "item_id": "B089WD97C2",
    "brand": "dr. gluten",
    "client": "test"
  },
  {
    "order": 18,
    "price": "Rs 369.00",
    "offer": "Rs 399.00",
    "page": 1,
    "link": "https://www.amazon.in//Kelloggs-Special-K-Original-900g/dp/B01CHUV3HE/",
    "page_count": 48,
    "reviews": 187,
    "ratings": 4.4,
    "image_count": 7,
    "product_name": "Kellogg's Special K Original Breakfast Cereal, 900g",
    "item_id": "B01CHUV3HE",
    "brand": "kellogg's",
    "client": "test"
  },
  {
    "order": 19,
    "price": "Rs 165.00",
    "offer": "Rs 295.00",
    "page": 1,
    "link": "https://www.amazon.in//Healthy-Balance-Corn-Flakes-875gm/dp/B07RJCQFYX/",
    "page_count": 48,
    "reviews": 111,
    "ratings": 4.3,
    "image_count": 7,
    "product_name": "Healthy Balance Corn Flakes 875gm",
    "item_id": "B07RJCQFYX",
    "brand": "healthy balance",
    "client": "test"
  },
  {
    "order": 20,
    "price": "Rs 250.00",
    "offer": null,
    "page": 1,
    "link": "https://www.amazon.in//Tops-Corn-Flakes-500gm-Pouch/dp/B08DLMRNWZ/",
    "page_count": 48,
    "reviews": 7,
    "ratings": 4.3,
    "image_count": 2,
    "product_name": "Tops Corn Flakes 500gm Pouch, Pack of 2",
    "item_id": "B08DLMRNWZ",
    "brand": "tops",
    "client": "test"
  },
  {
    "order": 21,
    "price": "Rs 427.00",
    "offer": "Rs 575.00",
    "page": 1,
    "link": "https://www.amazon.in//Bagrrys-Crunchy-Clusters-Almonds-Raisins/dp/B07P5RG55X/",
    "page_count": 48,
    "reviews": 252,
    "ratings": 4.4,
    "image_count": 7,
    "product_name": "Bagrry's Crunchy Muesli, Oat Clusters with Almonds, Raisins and Honey, 1000g Jar",
    "item_id": "B07P5RG55X",
    "brand": "bagrry's",
    "client": "test"
  },
  {
    "order": 22,
    "price": "Rs 185.00",
    "offer": null,
    "page": 1,
    "link": "https://www.amazon.in//Patanjali-Corn-Flakes-875-g/dp/B084W3BFN8/",
    "page_count": 48,
    "reviews": 0,
    "ratings": 5,
    "image_count": 7,
    "product_name": "Patanjali Corn Flakes, 875 g",
    "item_id": "B084W3BFN8",
    "brand": "patanjali",
    "client": "test"
  },
  {
    "order": 23,
    "price": "Rs 130.00",
    "offer": null,
    "page": 1,
    "link": "https://www.amazon.in//8AM-Cornflakes-500g/dp/B07FK4DVGN/",
    "page_count": 48,
    "reviews": 3,
    "ratings": 4.4,
    "image_count": 7,
    "product_name": "8AM Cornflakes 500g",
    "item_id": "B07FK4DVGN",
    "brand": "8am",
    "client": "test"
  },
  {
    "order": 24,
    "price": "Rs 119.00",
    "offer": "Rs 120.00",
    "page": 1,
    "link": "https://www.amazon.in//Bagrrys-Lawrence-Mills-Cornflakes-500g/dp/B01JSJRZAQ/",
    "page_count": 48,
    "reviews": 216,
    "ratings": 4.1,
    "image_count": 6,
    "product_name": "Lawrence Mills Cornflakes, 500g",
    "item_id": "B01JSJRZAQ",
    "brand": "bagrry's",
    "client": "test"
  },
  {
    "order": 25,
    "price": "Rs 220.00",
    "offer": "Rs 350.00",
    "page": 1,
    "link": "https://www.amazon.in//KWALITY-Kwality-Corn-Flakes-800g/dp/B07NTNN96Q/",
    "page_count": 48,
    "reviews": 26,
    "ratings": 4.2,
    "image_count": 3,
    "product_name": "Kwality Corn Flakes, Made with Golden Corns, 99% Fat Free, Natural Source of Vitamin, Iron and Protein (800G, Pack of 1)",
    "item_id": "B07NTNN96Q",
    "brand": "kwality",
    "client": "test"
  },
  {
    "order": 26,
    "price": "Rs 499.00",
    "offer": "Rs 798.00",
    "page": 1,
    "link": "https://www.amazon.in//Swad-Strawberry-Multigrain-Breakfast-Cholesterol/dp/B084SZDDJH/",
    "page_count": 48,
    "reviews": 0,
    "ratings": 5,
    "image_count": 7,
    "product_name": "Swad Strawberry Fills & Honey Corn Flakes, Combo of 2 Jars (Multigrain Breakfast Cereals with Zero Cholesterol & High Fibre) Jar, 670 g",
    "item_id": "B084SZDDJH",
    "brand": "swad",
    "client": "test"
  },
  {
    "order": 27,
    "price": "Rs 260.00",
    "offer": null,
    "page": 1,
    "link": "https://www.amazon.in//Jainys-Corn-Flakes-Low-Vitamins/dp/B088QG74Z7/",
    "page_count": 48,
    "reviews": 19,
    "ratings": 4.2,
    "image_count": 3,
    "product_name": "Jainys Corn Flakes, Low in Fat with Vitamins - 2 Pack, 2 x 500 g",
    "item_id": "B088QG74Z7",
    "brand": "jainys",
    "client": "test"
  },
  {
    "order": 28,
    "price": "Rs 375.00",
    "offer": "Rs 399.00",
    "page": 1,
    "link": "https://www.amazon.in//Kelloggs-Special-K-900-gms/dp/B00TIMNSSM/",
    "page_count": 48,
    "reviews": 399,
    "ratings": 4.2,
    "image_count": 7,
    "product_name": "Kellogg's Special K Original, Breakfast Cereals, 900g",
    "item_id": "B00TIMNSSM",
    "brand": "kellogg's",
    "client": "test"
  },
  {
    "order": 29,
    "price": "Rs 299.00",
    "offer": "Rs 399.00",
    "page": 1,
    "link": "https://www.amazon.in//Bagrrys-Corn-Flakes-Plus-Healthier-1Kg/dp/B08QGKJP6C/",
    "page_count": 48,
    "reviews": 0,
    "ratings": 0,
    "image_count": 7,
    "product_name": "Bagrrys Corn Flakes Plus – Original and Healthier 1Kg Pouch",
    "item_id": "B08QGKJP6C",
    "brand": "bagrry's",
    "client": "test"
  },
  {
    "order": 30,
    "price": null,
    "offer": null,
    "page": 1,
    "link": "https://www.amazon.in//Amazon-Brand-Solimo-Corn-Flakes/dp/B083NXPRL5/",
    "page_count": 48,
    "reviews": 29,
    "ratings": 4.2,
    "image_count": 7,
    "product_name": "Amazon Brand - Solimo Corn Flakes, 500g",
    "item_id": "B083NXPRL5",
    "brand": "amazon brand - solimo",
    "client": "test"
  },
  {
    "order": 31,
    "price": "Rs 306.00",
    "offer": "Rs 330.00",
    "page": 1,
    "link": "https://www.amazon.in//Nestle-Koko-Krunch-Breakfast-Cereal/dp/B084G23HQ4/",
    "page_count": 48,
    "reviews": 107,
    "ratings": 4.3,
    "image_count": 7,
    "product_name": "Nestle Koko Krunch Breakfast Cereal - Choco Burst, 500 g Box",
    "item_id": "B084G23HQ4",
    "brand": "nestle",
    "client": "test"
  },
  {
    "order": 32,
    "price": "Rs 299.00",
    "offer": "Rs 315.00",
    "page": 1,
    "link": "https://www.amazon.in//Kelloggs-Muesli-Nuts-Delight-500g/dp/B083QQXVF2/",
    "page_count": 48,
    "reviews": 366,
    "ratings": 4.5,
    "image_count": 7,
    "product_name": "Kellogg's Muesli with 20% Nuts Delight, 500g",
    "item_id": "B083QQXVF2",
    "brand": "kellogg's",
    "client": "test"
  },
  {
    "order": 33,
    "price": "Rs 140.00",
    "offer": null,
    "page": 1,
    "link": "https://www.amazon.in//Kelloggs-Corn-Flakes-Real-Honey/dp/B0156LX9K0/",
    "page_count": 48,
    "reviews": 21,
    "ratings": 4.4,
    "image_count": 6,
    "product_name": "Kellogg's Corn Flakes with Real Honey, 300g",
    "item_id": "B0156LX9K0",
    "brand": "kellogg's",
    "client": "test"
  },
  {
    "order": 34,
    "price": "Rs 180.00",
    "offer": null,
    "page": 1,
    "link": "https://www.amazon.in//Nestle-Nesplus-Crunchy-Flakes-Extra/dp/B089P9P5QM/",
    "page_count": 48,
    "reviews": 8,
    "ratings": 4.3,
    "image_count": 7,
    "product_name": "Nestle Nesplus Crunchy Flakes: Corn and Oats, 570g Box (475g + 95g)",
    "item_id": "B089P9P5QM",
    "brand": "nesplus",
    "client": "test"
  },
  {
    "order": 35,
    "price": null,
    "offer": "Rs 290.00",
    "page": 1,
    "link": "https://www.amazon.in//Monsoon-Harvest-Fiber-Breakfast-Cereal/dp/B08N6MC3JF/",
    "page_count": 48,
    "reviews": 1,
    "ratings": 5,
    "image_count": 6,
    "product_name": "Monsoon Harvest High Fiber Breakfast Cereal with No Added Sugar - Ragi Flakes with Raisins, 400g",
    "item_id": "B08N6MC3JF",
    "brand": "monsoon harvest",
    "client": "test"
  },
  {
    "order": 36,
    "price": "Rs 299.00",
    "offer": "Rs 415.00",
    "page": 1,
    "link": "https://www.amazon.in//Percy-Breakfast-Cereal-Vanilla-Wholegrain/dp/B07SKHMW1V/",
    "page_count": 48,
    "reviews": 11,
    "ratings": 3.5,
    "image_count": 5,
    "product_name": "Percy Breakfast Cereal, Choco Vanilla Flakes, Jumbo Jar [2in1 Duet, Wholegrain Chocos and High Fibre] Jar, 380 g",
    "item_id": "B07SKHMW1V",
    "brand": "percy",
    "client": "test"
  },
  {
    "order": 37,
    "price": "Rs 499.00",
    "offer": "Rs 1,198.00",
    "page": 1,
    "link": "https://www.amazon.in//Swad-Flakes-Breakfast-Cereals-Chocos/dp/B084TLKHX6/",
    "page_count": 48,
    "reviews": 0,
    "ratings": 4.6,
    "image_count": 7,
    "product_name": "Swad Fruit Rings N Balls & Choco Flakes, Combo of 2 Jars (High Fibre Breakfast Cereals Chocos Froot Loops Kids) Jar, 660 g",
    "item_id": "B084TLKHX6",
    "brand": "swad",
    "client": "test"
  },
  {
    "order": 38,
    "price": "Rs 499.00",
    "offer": "Rs 1,198.00",
    "page": 1,
    "link": "https://www.amazon.in//Swad-Flakes-Wholegrain-Cereal-Breakfast/dp/B084TMRKFQ/",
    "page_count": 48,
    "reviews": 0,
    "ratings": 3,
    "image_count": 7,
    "product_name": "Swad Fruit Rings & Honey Corn Flakes, Combo of 2 Jars (Wholegrain Fruit Loops Corn Cereal for Breakfast Jar, 610 g",
    "item_id": "B084TMRKFQ",
    "brand": "swad",
    "client": "test"
  },
  {
    "order": 39,
    "price": "Rs 95.00",
    "offer": null,
    "page": 1,
    "link": "https://www.amazon.in//Kelloggs-Corn-Flakes-original-shakti/dp/B00TZIH8WG/",
    "page_count": 48,
    "reviews": 44,
    "ratings": 4.5,
    "image_count": 6,
    "product_name": "Kellogg's Corn Flakes Original, Breakfast Cereal, 250g",
    "item_id": "B00TZIH8WG",
    "brand": "kellogg's",
    "client": "test"
  },
  {
    "order": 40,
    "price": "Rs 205.00",
    "offer": null,
    "page": 1,
    "link": "https://www.amazon.in//Murginns-MURGINNS-Bajra-Flakes-275g/dp/B07MKBP9FC/",
    "page_count": 48,
    "reviews": 6,
    "ratings": 3.5,
    "image_count": 7,
    "product_name": "Murginns Bajra Flakes | Gluten Free | Healthy Breakfast, 275g",
    "item_id": "B07MKBP9FC",
    "brand": "murginns",
    "client": "test"
  },
  {
    "order": 41,
    "price": "Rs 558.00",
    "offer": "Rs 600.00",
    "page": 1,
    "link": "https://www.amazon.in//Happy-Day-Crunchy-Muesli-Multigrains/dp/B08DKSPV7Y/",
    "page_count": 48,
    "reviews": 1,
    "ratings": 5,
    "image_count": 7,
    "product_name": "Happy Day Crunchy Muesli - Fruit & Nut, Made with 5 Multigrains | High Fibre, Low Fat Breakfast Cereal | Nutrition Rich Meal- 500 GM (Pack of 2)",
    "item_id": "B08DKSPV7Y",
    "brand": "happy day",
    "client": "test"
  },
  {
    "order": 42,
    "price": "Rs 279.00",
    "offer": "Rs 300.00",
    "page": 1,
    "link": "https://www.amazon.in//Happy-Day-Crunchy-Muesli-Multigrains/dp/B08DKT31B3/",
    "page_count": 48,
    "reviews": 2,
    "ratings": 5,
    "image_count": 7,
    "product_name": "Happy Day Crunchy Muesli - Almond & Raisin, Made with 5 Multigrains | High Fibre, Low Fat Breakfast Cereal | Nutrition Rich Meal - 500 GM",
    "item_id": "B08DKT31B3",
    "brand": "happy day",
    "client": "test"
  },
  {
    "order": 43,
    "price": "Rs 198.00",
    "offer": null,
    "page": 1,
    "link": "https://www.amazon.in//Natureland-Organics-Corn-Flakes-Pouch/dp/B07T2TSHG8/",
    "page_count": 48,
    "reviews": 18,
    "ratings": 3.7,
    "image_count": 3,
    "product_name": "Natureland Organics Corn Flakes Pouch 200 Gm (2 x 200 gm) - Organic Healthy Flakes",
    "item_id": "B07T2TSHG8",
    "brand": "natureland organics",
    "client": "test"
  },
  {
    "order": 44,
    "price": "Rs 180.00",
    "offer": null,
    "page": 1,
    "link": "https://www.amazon.in//Bagrrys-Original-Healthier-Corn-Flakes/dp/B01H1XMS6M/",
    "page_count": 48,
    "reviews": 50,
    "ratings": 4.1,
    "image_count": 7,
    "product_name": "Bagrrys Original and Healthier Corn Flakes Plus, 475g",
    "item_id": "B01H1XMS6M",
    "brand": "bagrry's",
    "client": "test"
  },
  {
    "order": 45,
    "price": "Rs 470.00",
    "offer": null,
    "page": 1,
    "link": "https://www.amazon.in//Bagrrys-Choco-Plus-1-2kg-Pouch/dp/B07H51BS1D/",
    "page_count": 48,
    "reviews": 55,
    "ratings": 4.3,
    "image_count": 4,
    "product_name": "Bagrry's Choco+ 1.2 Kg Pouch",
    "item_id": "B07H51BS1D",
    "brand": "bagrry's",
    "client": "test"
  },
  {
    "order": 46,
    "price": "Rs 349.00",
    "offer": "Rs 499.00",
    "page": 1,
    "link": "https://www.amazon.in//Bagrrys-Fruit-Muesli-Cranberries-750g/dp/B07KMHZG5H/",
    "page_count": 48,
    "reviews": 139,
    "ratings": 4.4,
    "image_count": 6,
    "product_name": "Bagrrys Fruit and Nut Muesli with Cranberries, 750g",
    "item_id": "B07KMHZG5H",
    "brand": "bagrry's",
    "client": "test"
  },
  {
    "order": 47,
    "price": "Rs 399.00",
    "offer": "Rs 449.00",
    "page": 1,
    "link": "https://www.amazon.in//Bagrrys-Crunchy-Clusters-Almonds-Raisins/dp/B07M93RT18/",
    "page_count": 48,
    "reviews": 14,
    "ratings": 4.3,
    "image_count": 5,
    "product_name": "Bagrry's Crunchy Muesli, Oat Clusters with Almonds, Raisins and Honey, 750 GM Pouch",
    "item_id": "B07M93RT18",
    "brand": "bagrry's",
    "client": "test"
  },
  {
    "order": 48,
    "price": "Rs 301.50",
    "offer": "Rs 335.00",
    "page": 1,
    "link": "https://www.amazon.in//Nestl%C3%A9-NesPlus-Breakfast-Cereal-Crunchy/dp/B07Z9LV23Z/",
    "page_count": 48,
    "reviews": 22,
    "ratings": 4.1,
    "image_count": 7,
    "product_name": "Nestlé NesPlus Breakfast Cereal - Crunchy Granola with Nutty Honey, 475g Pouch",
    "item_id": "B07Z9LV23Z",
    "brand": "nestle",
    "client": "test"
  },
  {
    "order": 49,
    "price": "Rs 280.00",
    "offer": "Rs 398.00",
    "page": 2,
    "link": "https://www.amazon.in//Kwality-Corn-Flakes-Original-375g/dp/B07PX28CH3/",
    "page_count": 48,
    "reviews": 4,
    "ratings": 4.2,
    "image_count": 6,
    "product_name": "Kwality Corn Flakes, Made with Golden Corns, 99% Fat Free, Natural Source of Vitamin, Iron and Protein (375G, Pack of 2)",
    "item_id": "B07PX28CH3",
    "brand": "kwality",
    "client": "test"
  },
  {
    "order": 50,
    "price": null,
    "offer": "Rs 400.00",
    "page": 2,
    "link": "https://www.amazon.in//True-Elements-Jowar-Flakes-750g/dp/B084P9P9K2/",
    "page_count": 48,
    "reviews": 13,
    "ratings": 4.1,
    "image_count": 6,
    "product_name": "True Elements Jowar Flakes 750g - Millet Flakes, Cereal for Breakfast, Healthier Version of Corn Flakes, Diet Food",
    "item_id": "B084P9P9K2",
    "brand": "true elements",
    "client": "test"
  },
  {
    "order": 51,
    "price": null,
    "offer": "Rs 260.00",
    "page": 2,
    "link": "https://www.amazon.in//Monsoon-Harvest-Clusters-Flakes-Strawberry/dp/B07BFRMKNS/",
    "page_count": 48,
    "reviews": 87,
    "ratings": 4.3,
    "image_count": 6,
    "product_name": "Monsoon Harvest Oats Clusters & Ragi Flakes with Strawberry, 350 g",
    "item_id": "B07BFRMKNS",
    "brand": "monsoon harvest",
    "client": "test"
  },
  {
    "order": 52,
    "price": "Rs 558.00",
    "offer": "Rs 600.00",
    "page": 2,
    "link": "https://www.amazon.in//Happy-Day-Crunchy-Muesli-Multigrains/dp/B08DKQ4RQ2/",
    "page_count": 48,
    "reviews": 1,
    "ratings": 5,
    "image_count": 7,
    "product_name": "Happy Day Crunchy Muesli - Berry Mix, Made with 5 Multigrains | High Fibre, Low Fat Breakfast Cereal | Nutrition Rich Meal- 500 GM (Pack of 2)",
    "item_id": "B08DKQ4RQ2",
    "brand": "happy day",
    "client": "test"
  },
  {
    "order": 53,
    "price": null,
    "offer": "Rs 720.00",
    "page": 2,
    "link": "https://www.amazon.in//True-Elements-Muesli-Crunchy-Refill/dp/B07V9LBM5S/",
    "page_count": 48,
    "reviews": 121,
    "ratings": 4.3,
    "image_count": 6,
    "product_name": "True Elements Muesli No Added Sugar 1.2 kg - High Fibre, Wholegrain Cereal, Super Saver Pack, Muesli Sugar Free",
    "item_id": "B07V9LBM5S",
    "brand": "true elements",
    "client": "test"
  },
  {
    "order": 54,
    "price": "Rs 225.00",
    "offer": null,
    "page": 2,
    "link": "https://www.amazon.in//MURGINNS-Crispy-Oat-Flakes-275g/dp/B07MNDT99Q/",
    "page_count": 48,
    "reviews": 2,
    "ratings": 4,
    "image_count": 7,
    "product_name": "Murginns Oat Flakes, 275G",
    "item_id": "B07MNDT99Q",
    "brand": "murginns",
    "client": "test"
  },
  {
    "order": 55,
    "price": "Rs 275.00",
    "offer": null,
    "page": 2,
    "link": "https://www.amazon.in//Soulfull-Diet-Millet-Muesli-400g/dp/B073GPYBJM/",
    "page_count": 48,
    "reviews": 99,
    "ratings": 4.2,
    "image_count": 4,
    "product_name": "Soulfull Millet Muesli Diet- No Sugar Added , 400g",
    "item_id": "B073GPYBJM",
    "brand": "soulfull",
    "client": "test"
  },
  {
    "order": 56,
    "price": "Rs 499.00",
    "offer": "Rs 575.00",
    "page": 2,
    "link": "https://www.amazon.in//Bagrrys-Crunchy-Clusters-Almonds-Raisins/dp/B00LA5NZR4/",
    "page_count": 48,
    "reviews": 1247,
    "ratings": 4.3,
    "image_count": 7,
    "product_name": "Bagrry's Crunchy Muesli Oat Clusters with Almonds, Raisins & Honey, 1000 GM",
    "item_id": "B00LA5NZR4",
    "brand": "bagrry's",
    "client": "test"
  },
  {
    "order": 57,
    "price": "Rs 499.00",
    "offer": "Rs 1,198.00",
    "page": 2,
    "link": "https://www.amazon.in//Swad-Strawberry-Cholesterol-Crunchy-Cereal/dp/B084SYYH4J/",
    "page_count": 48,
    "reviews": 7,
    "ratings": 3.9,
    "image_count": 7,
    "product_name": "Swad Strawberry Fills & Fruit Rings, Combo of 2 Jars (Zero Cholesterol, High Fibre Crunchy Fruit Loops Cereal) Jar, 650 g",
    "item_id": "B084SYYH4J",
    "brand": "swad",
    "client": "test"
  },
  {
    "order": 58,
    "price": "Rs 169.00",
    "offer": null,
    "page": 2,
    "link": "https://www.amazon.in//Soulfull-Vanilla-Fills-Bites-Large/dp/B00M34R234/",
    "page_count": 48,
    "reviews": 51,
    "ratings": 4.3,
    "image_count": 4,
    "product_name": "Soulfull Vanilla Fills - Ragi Bites 250gm",
    "item_id": "B00M34R234",
    "brand": "soulfull",
    "client": "test"
  },
  {
    "order": 59,
    "price": "Rs 160.00",
    "offer": "Rs 190.00",
    "page": 2,
    "link": "https://www.amazon.in//Quaker-Oats-1-kg-Pack/dp/B01GCEQKY2/",
    "page_count": 48,
    "reviews": 277,
    "ratings": 4.5,
    "image_count": 6,
    "product_name": "Quaker Oats - 1 kg",
    "item_id": "B01GCEQKY2",
    "brand": "quaker",
    "client": "test"
  },
  {
    "order": 60,
    "price": "Rs 437.00",
    "offer": "Rs 470.00",
    "page": 2,
    "link": "https://www.amazon.in//Kelloggs-Chocos-1-2kg-North/dp/B07K8T373W/",
    "page_count": 48,
    "reviews": 518,
    "ratings": 4.5,
    "image_count": 7,
    "product_name": "Kellogg's Chocos, 1.2kg",
    "item_id": "B07K8T373W",
    "brand": "kellogg's",
    "client": "test"
  },
  {
    "order": 61,
    "price": "Rs 285.00",
    "offer": "Rs 315.00",
    "page": 2,
    "link": "https://www.amazon.in//Kelloggs-Muesli-21-Fruit-500g/dp/B083QQXVF3/",
    "page_count": 48,
    "reviews": 633,
    "ratings": 4.5,
    "image_count": 7,
    "product_name": "Kellogg's Muesli with 21% Fruit and Nut, 500g",
    "item_id": "B083QQXVF3",
    "brand": "kellogg's",
    "client": "test"
  },
  {
    "order": 62,
    "price": "Rs 489.58",
    "offer": "Rs 640.00",
    "page": 2,
    "link": "https://www.amazon.in//Kelloggs-Chocos-Moons-Stars-Pouch/dp/B07L94T8P7/",
    "page_count": 48,
    "reviews": 217,
    "ratings": 4.4,
    "image_count": 7,
    "product_name": "Kellogg's Chocos Moons and Stars 1.2 kg Pouch",
    "item_id": "B07L94T8P7",
    "brand": "kellogg's",
    "client": "test"
  },
  {
    "order": 63,
    "price": "Rs 499.00",
    "offer": "Rs 748.00",
    "page": 2,
    "link": "https://www.amazon.in//Swad-Flakes-Wholegrain-Chocolate-Breakfast/dp/B084TM247P/",
    "page_count": 48,
    "reviews": 2,
    "ratings": 3.3,
    "image_count": 7,
    "product_name": "Swad Choco Flakes & Corn Flakes, Combo of 2 Jars (Wholegrain Chocolate Breakfast Cereal Kokos Chocos Kids) Jar, 620 g",
    "item_id": "B084TM247P",
    "brand": "swad",
    "client": "test"
  },
  {
    "order": 64,
    "price": null,
    "offer": "Rs 350.00",
    "page": 2,
    "link": "https://www.amazon.in//True-Elements-Multigrain-Flakes-Honey/dp/B08CH9K2R8/",
    "page_count": 48,
    "reviews": 6,
    "ratings": 3.9,
    "image_count": 7,
    "product_name": "True Elements Multigrain Flakes with Honey 750g - Flakes for Breakfast, Power of Wheat Flakes, Jowar Flakes & Bajra Flakes",
    "item_id": "B08CH9K2R8",
    "brand": "true elements",
    "client": "test"
  },
  {
    "order": 65,
    "price": "Rs 325.00",
    "offer": null,
    "page": 2,
    "link": "https://www.amazon.in//Dr-Schar-Corn-Flakes-250g/dp/B00DN9MZ2Q/",
    "page_count": 48,
    "reviews": 17,
    "ratings": 4.2,
    "image_count": 7,
    "product_name": "Dr. Schar Gluten Free Corn Flakes, 250g",
    "item_id": "B00DN9MZ2Q",
    "brand": "dr. schar",
    "client": "test"
  },
  {
    "order": 66,
    "price": null,
    "offer": "Rs 400.00",
    "page": 2,
    "link": "https://www.amazon.in//True-Elements-Flakes-Crunchier-Version/dp/B085DJ8ZY3/",
    "page_count": 48,
    "reviews": 19,
    "ratings": 4.4,
    "image_count": 6,
    "product_name": "True Elements Wheat Flakes 750gm - No Added Sugar, 100% Wholegrain Cereal, Flakes for Kids, Healthy Breakfast",
    "item_id": "B085DJ8ZY3",
    "brand": "true elements",
    "client": "test"
  },
  {
    "order": 67,
    "price": "Rs 349.00",
    "offer": "Rs 499.00",
    "page": 2,
    "link": "https://www.amazon.in//Percy-Breakfast-Strawberry-Multigrain-Cholesterol/dp/B07SGCPRG7/",
    "page_count": 48,
    "reviews": 4,
    "ratings": 3.3,
    "image_count": 6,
    "product_name": "Percy Breakfast Cereal, Strawberry Fills, Multigrain, Jumbo Jar [Zero Cholesterol, Crunchy and Creamy Fills] Jar, 520 g",
    "item_id": "B07SGCPRG7",
    "brand": "percy",
    "client": "test"
  },
  {
    "order": 68,
    "price": "Rs 130.00",
    "offer": null,
    "page": 2,
    "link": "https://www.amazon.in//Jainys-Corn-Flakes-500g/dp/B088QFS89P/",
    "page_count": 48,
    "reviews": 32,
    "ratings": 4,
    "image_count": 2,
    "product_name": "Jainys Corn Flakes, 500g",
    "item_id": "B088QFS89P",
    "brand": "jainys",
    "client": "test"
  },
  {
    "order": 69,
    "price": "Rs 499.00",
    "offer": "Rs 1,198.00",
    "page": 2,
    "link": "https://www.amazon.in//Swad-Strawberry-Fills-Multigrain-Cereal/dp/B084TL9QPV/",
    "page_count": 48,
    "reviews": 3,
    "ratings": 3.6,
    "image_count": 7,
    "product_name": "Swad Strawberry Fills & Fruit Rings N Balls, Combo of 2 Jars (Multigrain Froot Loops, High Fibre Cream Cereal) Jar, 680 g",
    "item_id": "B084TL9QPV",
    "brand": "swad",
    "client": "test"
  },
  {
    "order": 70,
    "price": "Rs 233.75",
    "offer": "Rs 275.00",
    "page": 2,
    "link": "https://www.amazon.in//Soulfull-Crunchy-Millet-Almonds-Raisins/dp/B073GRFF8B/",
    "page_count": 48,
    "reviews": 161,
    "ratings": 4.2,
    "image_count": 7,
    "product_name": "Soulfull Millet Muesli Crunchy Contains Almonds & Raisins, 400g",
    "item_id": "B073GRFF8B",
    "brand": "soulfull",
    "client": "test"
  },
  {
    "order": 71,
    "price": "Rs 269.00",
    "offer": "Rs 399.00",
    "page": 2,
    "link": "https://www.amazon.in//Swad-Breakfast-Cereal-Flakes-Cholesterol/dp/B084RNNNNW/",
    "page_count": 48,
    "reviews": 0,
    "ratings": 4,
    "image_count": 7,
    "product_name": "Swad Breakfast Cereal, Honey Corn Flakes with Real Honey (Zero Cholesterol, High Fibre Corn & Iron Rich) Jar, 300 g",
    "item_id": "B084RNNNNW",
    "brand": "swad",
    "client": "test"
  },
  {
    "order": 72,
    "price": null,
    "offer": "Rs 740.00",
    "page": 2,
    "link": "https://www.amazon.in//Monsoon-Harvest-Toasted-Millet-Pistachios/dp/B07W9DPYXN/",
    "page_count": 48,
    "reviews": 47,
    "ratings": 4.5,
    "image_count": 6,
    "product_name": "Monsoon Harvest Toasted Millet Muesli, Fig & Honey with Salted Pistachios, 1 Kg",
    "item_id": "B07W9DPYXN",
    "brand": "monsoon harvest",
    "client": "test"
  },
  {
    "order": 73,
    "price": null,
    "offer": "Rs 595.00",
    "page": 2,
    "link": "https://www.amazon.in//True-Elements-Cranberry-Blueberry-Muesli/dp/B07G17S1Q8/",
    "page_count": 48,
    "reviews": 57,
    "ratings": 4.3,
    "image_count": 7,
    "product_name": "True Elements Cranberry Blueberry Muesli 1kg - Fibre Rich Breakfast Cereal",
    "item_id": "B07G17S1Q8",
    "brand": "true elements",
    "client": "test"
  },
  {
    "order": 74,
    "price": "Rs 439.00",
    "offer": "Rs 499.00",
    "page": 2,
    "link": "https://www.amazon.in//Bagrrys-Crunchy-Muesli-Fruit-Cranberries/dp/B07M8W8H7Q/",
    "page_count": 48,
    "reviews": 371,
    "ratings": 4.3,
    "image_count": 5,
    "product_name": "Bagrry's Crunchy Muesli Fruit N Nut with Cranberries 750 GM Pouch",
    "item_id": "B07M8W8H7Q",
    "brand": "bagrry's",
    "client": "test"
  },
  {
    "order": 75,
    "price": "Rs 212.00",
    "offer": "Rs 295.00",
    "page": 2,
    "link": "https://www.amazon.in//True-Elements-Added-Sugar-Muesli/dp/B07GNT9YDM/",
    "page_count": 48,
    "reviews": 94,
    "ratings": 4.1,
    "image_count": 6,
    "product_name": "True Elements Muesli Sugar Free with Real Fruits 400g - Wholegrain Breakfast Cereal",
    "item_id": "B07GNT9YDM",
    "brand": "true elements",
    "client": "test"
  },
  {
    "order": 76,
    "price": "Rs 500.00",
    "offer": "Rs 575.00",
    "page": 2,
    "link": "https://www.amazon.in//Gaia-Muesli-Nutty-Delight-Kg/dp/B017783D56/",
    "page_count": 48,
    "reviews": 78,
    "ratings": 4.3,
    "image_count": 5,
    "product_name": "Gaia Crunchy Muesli Nutty Delight with Rolled Oats, Wheat, Corn Flakes, Assorted Nuts and Seeds.1 Kg",
    "item_id": "B017783D56",
    "brand": "gaia",
    "client": "test"
  },
  {
    "order": 77,
    "price": "Rs 399.00",
    "offer": "Rs 899.00",
    "page": 2,
    "link": "https://www.amazon.in//Percy-Breakfast-Cereal-Multigrain-Flavoured/dp/B07SGCNST9/",
    "page_count": 48,
    "reviews": 82,
    "ratings": 3.3,
    "image_count": 6,
    "product_name": "Percy Breakfast Cereal, Fruit Rings, Multigrain, Jumbo Jar [Mix Fruit Loops Flavoured, High Fibre and Multigrain] Jar, 340 g",
    "item_id": "B07SGCNST9",
    "brand": "percy",
    "client": "test"
  },
  {
    "order": 78,
    "price": "Rs 249.00",
    "offer": "Rs 270.00",
    "page": 2,
    "link": "https://www.amazon.in//Swad-Breakfast-Cereal-Flakes-Cholesterol/dp/B084R9VW65/",
    "page_count": 48,
    "reviews": 1,
    "ratings": 3.3,
    "image_count": 6,
    "product_name": "Swad Breakfast Cereal, Low Fat Corn Flakes (99% Fat Free, Zero Cholesterol, High Fibre Corn & Iron Rich) Jar, 270 g",
    "item_id": "B084R9VW65",
    "brand": "swad",
    "client": "test"
  },
  {
    "order": 79,
    "price": null,
    "offer": "Rs 320.00",
    "page": 2,
    "link": "https://www.amazon.in//Kelloggs-Rolled-Oats-Protein-Fibre/dp/B07QWY23DF/",
    "page_count": 48,
    "reviews": 659,
    "ratings": 4.3,
    "image_count": 7,
    "product_name": "Kellogg's Oats Trusted by Nutritionists Pouch, 2000 g",
    "item_id": "B07QWY23DF",
    "brand": "kellogg's",
    "client": "test"
  },
  {
    "order": 80,
    "price": null,
    "offer": "Rs 445.00",
    "page": 2,
    "link": "https://www.amazon.in//Healthy-Balance-Choco-Flakes-1-2kg/dp/B07RXJSWMR/",
    "page_count": 48,
    "reviews": 103,
    "ratings": 4.1,
    "image_count": 5,
    "product_name": "Healthy Balance Choco Flakes 1.2kg",
    "item_id": "B07RXJSWMR",
    "brand": "healthy balance",
    "client": "test"
  },
  {
    "order": 81,
    "price": "Rs 270.00",
    "offer": "Rs 300.00",
    "page": 2,
    "link": "https://www.amazon.in//Zerobeli-Real-Mango-Flakes-2x300gm/dp/B08JQJ9RYJ/",
    "page_count": 48,
    "reviews": 0,
    "ratings": 0,
    "image_count": 5,
    "product_name": "Zerobeli Real Mango Corn Flakes, 600 g(Pack of 2x300gm)",
    "item_id": "B08JQJ9RYJ",
    "brand": "zerobeli",
    "client": "test"
  },
  {
    "order": 82,
    "price": "Rs 999.00",
    "offer": "Rs 1,947.00",
    "page": 2,
    "link": "https://www.amazon.in//Percy-Multigrain-Breakfast-Strawberry-Cereals/dp/B07SHFMMJJ/",
    "page_count": 48,
    "reviews": 0,
    "ratings": 5,
    "image_count": 6,
    "product_name": "Percy Multigrain Breakfast Combo (Muesli Fruit & Nut, Strawberry Fills, Fruit Rings Cereals), 3 Jumbo Jars, 1.53kg Jar, 1530 g",
    "item_id": "B07SHFMMJJ",
    "brand": "percy",
    "client": "test"
  },
  {
    "order": 83,
    "price": "Rs 284.00",
    "offer": "Rs 315.00",
    "page": 2,
    "link": "https://www.amazon.in//Nourish-Quinoa-Muesli-Honey-Nuts/dp/B07BD1R6CQ/",
    "page_count": 48,
    "reviews": 81,
    "ratings": 4.3,
    "image_count": 7,
    "product_name": "Nourish You Quinoa Muesli, Honey and Nuts, 375g",
    "item_id": "B07BD1R6CQ",
    "brand": "nourishyou",
    "client": "test"
  },
  {
    "order": 84,
    "price": null,
    "offer": "Rs 595.00",
    "page": 2,
    "link": "https://www.amazon.in//True-Elements-Granola-Almonds-Cranberries/dp/B08331B6ZJ/",
    "page_count": 48,
    "reviews": 11,
    "ratings": 4.2,
    "image_count": 0,
    "product_name": "True Elements Crunchy Millet Granola 900g - Power of Millet Flakes, Wholegrain Cereal for Breakfast",
    "item_id": "B08331B6ZJ",
    "brand": "true elements",
    "client": "test"
  },
  {
    "order": 85,
    "price": "Rs 499.00",
    "offer": "Rs 798.00",
    "page": 2,
    "link": "https://www.amazon.in//Swad-Vanilla-Flakes-Multigrain-Chocolate/dp/B084TJRXGV/",
    "page_count": 48,
    "reviews": 0,
    "ratings": 0,
    "image_count": 7,
    "product_name": "Swad Choco Vanilla Flakes & Choco Fills, Combo of 2 Jars (Multigrain Chocos Fills, High Iron Chocolate Cereal) Jar, 720 g",
    "item_id": "B084TJRXGV",
    "brand": "swad",
    "client": "test"
  },
  {
    "order": 86,
    "price": "Rs 98.00",
    "offer": "Rs 99.00",
    "page": 2,
    "link": "https://www.amazon.in//Kelloggs-Corn-Flakes-Original-290g/dp/B07QC1ZCJF/",
    "page_count": 48,
    "reviews": 0,
    "ratings": 4.5,
    "image_count": 2,
    "product_name": "Kellogg's Corn Flakes - Original, 290g",
    "item_id": "B07QC1ZCJF",
    "brand": "kellogg's",
    "client": "test"
  },
  {
    "order": 87,
    "price": "Rs 225.00",
    "offer": null,
    "page": 2,
    "link": "https://www.amazon.in//MURGINNS-Organic-Ragi-Flakes-275g/dp/B07MS9Y384/",
    "page_count": 48,
    "reviews": 15,
    "ratings": 4.2,
    "image_count": 7,
    "product_name": "Murginns Organic Ragi Flakes | Healthy Breakfast with Jaggery | No Refined Sugar, 275g",
    "item_id": "B07MS9Y384",
    "brand": "murginns",
    "client": "test"
  },
  {
    "order": 88,
    "price": null,
    "offer": "Rs 350.00",
    "page": 2,
    "link": "https://www.amazon.in//True-Elements-Whole-Oatmeal-Fruits/dp/B07RGPFMY1/",
    "page_count": 48,
    "reviews": 29,
    "ratings": 4.1,
    "image_count": 6,
    "product_name": "True Elements Whole Oatmeal for Breakfast 500 gm - Diet Food, Healthy Breakfast, Made from Gluten Free Oats",
    "item_id": "B07RGPFMY1",
    "brand": "true elements",
    "client": "test"
  },
  {
    "order": 89,
    "price": "Rs 45.00",
    "offer": null,
    "page": 2,
    "link": "https://www.amazon.in//Kelloggs-Corn-Flakes-100g/dp/B00TZIH1NC/",
    "page_count": 48,
    "reviews": 8,
    "ratings": 4.4,
    "image_count": 6,
    "product_name": "Kellogg's Corn Flakes Original, 100g",
    "item_id": "B00TZIH1NC",
    "brand": "kellogg's",
    "client": "test"
  },
  {
    "order": 90,
    "price": "Rs 315.00",
    "offer": null,
    "page": 2,
    "link": "https://www.amazon.in//Kelloggs-Muesli-Nuts-Delight-Pouch/dp/B083JN1V1K/",
    "page_count": 48,
    "reviews": 132,
    "ratings": 4.4,
    "image_count": 5,
    "product_name": "Kellogg's Muesli with 20% Nuts Delight Pouch, 500 g",
    "item_id": "B083JN1V1K",
    "brand": "kellogg's",
    "client": "test"
  },
  {
    "order": 91,
    "price": "Rs 190.00",
    "offer": null,
    "page": 2,
    "link": "https://www.amazon.in//Dr-Gluten-Power-Flakes-Original/dp/B08QZ5S946/",
    "page_count": 48,
    "reviews": 0,
    "ratings": 0,
    "image_count": 6,
    "product_name": "Dr. Gluten Power Flakes, Original Corn Flakes, Gluten Free, 400gm(Pack of1)",
    "item_id": "B08QZ5S946",
    "brand": "dr. gluten",
    "client": "test"
  },
  {
    "order": 92,
    "price": "Rs 245.00",
    "offer": "Rs 315.00",
    "page": 2,
    "link": "https://www.amazon.in//Kelloggs-Crunchy-Granola-Almonds-Cranberries/dp/B07DPS1QJK/",
    "page_count": 48,
    "reviews": 290,
    "ratings": 4.5,
    "image_count": 7,
    "product_name": "Kellogg's Crunchy Granola Almonds & Cranberries, 460g",
    "item_id": "B07DPS1QJK",
    "brand": "kellogg's",
    "client": "test"
  },
  {
    "order": 93,
    "price": "Rs 135.00",
    "offer": "Rs 140.00",
    "page": 2,
    "link": "https://www.amazon.in//Kelloggs-Corn-Flakes-Strawberry-275g/dp/B0156LXGD0/",
    "page_count": 48,
    "reviews": 31,
    "ratings": 4.2,
    "image_count": 6,
    "product_name": "Kellogg's Corn Flakes Strawberry Flavour, Breakfast Cereal, 300g",
    "item_id": "B0156LXGD0",
    "brand": "kellogg's",
    "client": "test"
  },
  {
    "order": 94,
    "price": "Rs 199.00",
    "offer": "Rs 299.00",
    "page": 2,
    "link": "https://www.amazon.in//MINI-MALL-SUPER-MARKET-Healthy/dp/B08J3WTQKC/",
    "page_count": 48,
    "reviews": 0,
    "ratings": 4,
    "image_count": 6,
    "product_name": "MINI MALL SUPER MARKET Corn Flakes with made chaat Masala | Ready to Fry Healthy poha Snacks | 950 Grams",
    "item_id": "B08J3WTQKC",
    "brand": "mini mall super market",
    "client": "test"
  },
  {
    "order": 95,
    "price": null,
    "offer": "Rs 650.00",
    "page": 2,
    "link": "https://www.amazon.in//Yogabar-Wholegrain-Breakfast-Muesli-Fruits/dp/B07PPGG3C3/",
    "page_count": 48,
    "reviews": 1132,
    "ratings": 4.4,
    "image_count": 6,
    "product_name": "Yogabar Muesli Fruit and Nuts - Wholegrain Breakfast Cereals with Oats and Dry Fruits, High in Omega 3, Gluten Free Vegan Granola with Chia and Flax Seeds (400g - Pack of 2)",
    "item_id": "B07PPGG3C3",
    "brand": "yogabar",
    "client": "test"
  },
  {
    "order": 96,
    "price": "Rs 232.50",
    "offer": "Rs 310.00",
    "page": 2,
    "link": "https://www.amazon.in//Soulfull-Choco-Fills-Super-Saver/dp/B01MTIQ29N/",
    "page_count": 48,
    "reviews": 117,
    "ratings": 4.3,
    "image_count": 6,
    "product_name": "Soulfull Choco Fills Super Saver Pack, 500g",
    "item_id": "B01MTIQ29N",
    "brand": "soulfull",
    "client": "test"
  },
  {
    "order": 97,
    "price": null,
    "offer": "Rs 650.00",
    "page": 3,
    "link": "https://www.amazon.in//Yogabar-Wholegrain-Breakfast-Muesli-Fruits/dp/B07PPGG3C3/",
    "page_count": 48,
    "reviews": 1132,
    "ratings": 4.4,
    "image_count": 6,
    "product_name": "Yogabar Muesli Fruit and Nuts - Wholegrain Breakfast Cereals with Oats and Dry Fruits, High in Omega 3, Gluten Free Vegan Granola with Chia and Flax Seeds (400g - Pack of 2)",
    "item_id": "B07PPGG3C3",
    "brand": "yogabar",
    "client": "test"
  },
  {
    "order": 98,
    "price": "Rs 232.50",
    "offer": "Rs 310.00",
    "page": 3,
    "link": "https://www.amazon.in//Soulfull-Choco-Fills-Super-Saver/dp/B01MTIQ29N/",
    "page_count": 48,
    "reviews": 117,
    "ratings": 4.3,
    "image_count": 6,
    "product_name": "Soulfull Choco Fills Super Saver Pack, 500g",
    "item_id": "B01MTIQ29N",
    "brand": "soulfull",
    "client": "test"
  },
  {
    "order": 99,
    "price": "Rs 338.00",
    "offer": "Rs 499.00",
    "page": 3,
    "link": "https://www.amazon.in//Percy-Breakfast-Vanilla-Multigrain-Cholesterol/dp/B07SGCPRG5/",
    "page_count": 48,
    "reviews": 10,
    "ratings": 3.9,
    "image_count": 6,
    "product_name": "Percy Breakfast Cereal, Choco Vanilla Fills, Multigrain, Jumbo Jar [Zero Cholesterol, Crunchy and Creamy Choco Fill] Jar, 520 g",
    "item_id": "B07SGCPRG5",
    "brand": "percy",
    "client": "test"
  },
  {
    "order": 100,
    "price": "Rs 798.00",
    "offer": "Rs 1,169.00",
    "page": 3,
    "link": "https://www.amazon.in//Percy-Classic-Breakfast-cornflakes-Cereals/dp/B07SJF7SQ7/",
    "page_count": 48,
    "reviews": 0,
    "ratings": 0,
    "image_count": 6,
    "product_name": "Percy Classic Breakfast Combo (Classic cornflakes, Honey Corn Flakes and Chocos Flakes Cereals), 3 Jumbo Jars, 1180 g",
    "item_id": "B07SJF7SQ7",
    "brand": "percy",
    "client": "test"
  },
  {
    "order": 101,
    "price": "Rs 558.00",
    "offer": "Rs 600.00",
    "page": 3,
    "link": "https://www.amazon.in//Happy-Day-Crunchy-Muesli-Multigrains/dp/B08DKTJHMN/",
    "page_count": 48,
    "reviews": 2,
    "ratings": 3.9,
    "image_count": 7,
    "product_name": "Happy Day Crunchy Muesli - No Added Sugar, Made with 5 Multigrains | High Fibre, Low Fat Breakfast Cereal | Nutrition Rich Meal - 500 GM (Pack of 2)",
    "item_id": "B08DKTJHMN",
    "brand": "happy day",
    "client": "test"
  },
  {
    "order": 102,
    "price": "Rs 499.00",
    "offer": "Rs 798.00",
    "page": 3,
    "link": "https://www.amazon.in//Swad-Vanilla-Multigrain-Chocos-Cereal/dp/B084T16BGW/",
    "page_count": 48,
    "reviews": 0,
    "ratings": 5,
    "image_count": 7,
    "product_name": "Swad Choco Vanilla Fills & Choco Fills, Combo of 2 Jars (High Fibre Multigrain Chocos Fill and Vanilla Cream Cereal) Jar, 740 g",
    "item_id": "B084T16BGW",
    "brand": "swad",
    "client": "test"
  },
  {
    "order": 103,
    "price": "Rs 799.00",
    "offer": "Rs 1,338.00",
    "page": 3,
    "link": "https://www.amazon.in//Percy-Muesli-Classic-Cornflakes-Cholesterol/dp/B07SLLMPS4/",
    "page_count": 48,
    "reviews": 0,
    "ratings": 0,
    "image_count": 6,
    "product_name": "Percy Diet Muesli No Sugar, Classic Cornflakes, Combo Pack of 2 Jars [Zero Cholesterol, High Iron and Fibre Cereal] Jar, 1140 g",
    "item_id": "B07SLLMPS4",
    "brand": "percy",
    "client": "test"
  },
  {
    "order": 104,
    "price": "Rs 628.00",
    "offer": "Rs 914.00",
    "page": 3,
    "link": "https://www.amazon.in//Percy-Cornflakes-Strawberry-Multigrain-Cholesterol/dp/B07SKHQ7D8/",
    "page_count": 48,
    "reviews": 1,
    "ratings": 4,
    "image_count": 6,
    "product_name": "Percy Honey Cornflakes and Strawberry Fills, Multigrain Combo Pack of 2 Jars [Zero Cholesterol, High Fibre Crunchy Cereal] Jar, 850 g",
    "item_id": "B07SKHQ7D8",
    "brand": "percy",
    "client": "test"
  },
  {
    "order": 105,
    "price": "Rs 299.00",
    "offer": "Rs 399.00",
    "page": 3,
    "link": "https://www.amazon.in//Swad-Breakfast-Cereal-Wholegrain-Children/dp/B084RKJDCR/",
    "page_count": 48,
    "reviews": 1,
    "ratings": 3.3,
    "image_count": 7,
    "product_name": "Swad Breakfast Cereal, Wholegrain Choco Flakes (High Fibre Wheat Chocos Children Cereal) Jar, 350 g",
    "item_id": "B084RKJDCR",
    "brand": "swad",
    "client": "test"
  },
  {
    "order": 106,
    "price": "Rs 499.00",
    "offer": "Rs 799.00",
    "page": 3,
    "link": "https://www.amazon.in//Swad-Breakfast-Multigrain-Transfat-Cholesterol/dp/B084RJPRDY/",
    "page_count": 48,
    "reviews": 1,
    "ratings": 2.7,
    "image_count": 7,
    "product_name": "Swad Breakfast Cereal, Diet Muesli No Added Sugar (Multigrain Crunchy Oats, High Fibre, High Protein, Zero Transfat & Zero Cholesterol Muesli) Jar, 700 g",
    "item_id": "B084RJPRDY",
    "brand": "swad",
    "client": "test"
  },
  {
    "order": 107,
    "price": "Rs 499.00",
    "offer": "Rs 798.00",
    "page": 3,
    "link": "https://www.amazon.in//Swad-Vanilla-Wholegrain-Chocolate-Breakfast/dp/B084TM5ST7/",
    "page_count": 48,
    "reviews": 0,
    "ratings": 5,
    "image_count": 7,
    "product_name": "Swad Choco Flakes & Choco Vanilla Flakes, Combo of 2 Jars (Wholegrain Chocolate Breakfast Cereal Chocos Kids) Jar, 700 g",
    "item_id": "B084TM5ST7",
    "brand": "swad",
    "client": "test"
  },
  {
    "order": 108,
    "price": "Rs 299.00",
    "offer": "Rs 399.00",
    "page": 3,
    "link": "https://www.amazon.in//Swad-Breakfast-Wholegrain-Vanilla-Cholesterol/dp/B084RP9QR3/",
    "page_count": 48,
    "reviews": 0,
    "ratings": 3,
    "image_count": 7,
    "product_name": "Swad Breakfast Cereal, Wholegrain Choco Vanilla Flakes (Zero Cholesterol, Duet High Fibre Wheat Chocos) Jar, 350 g",
    "item_id": "B084RP9QR3",
    "brand": "swad",
    "client": "test"
  },
  {
    "order": 109,
    "price": null,
    "offer": "Rs 480.00",
    "page": 3,
    "link": "https://www.amazon.in//True-Elements-Rolled-Gluten-Protein/dp/B07T3RB539/",
    "page_count": 48,
    "reviews": 422,
    "ratings": 4.4,
    "image_count": 6,
    "product_name": "True Elements Rolled Oats 1.2 kg - Gluten Free Oats, Rolled Oats for Weight Loss, Healthy Breakfast, Super Saver Pack",
    "item_id": "B07T3RB539",
    "brand": "true elements",
    "client": "test"
  },
  {
    "order": 110,
    "price": "Rs 598.00",
    "offer": "Rs 830.00",
    "page": 3,
    "link": "https://www.amazon.in//Percy-Flakes-Vanilla-Cholesterol-Chocos/dp/B07SKHQ7DZ/",
    "page_count": 48,
    "reviews": 2,
    "ratings": 4.5,
    "image_count": 6,
    "product_name": "Percy Choco Flakes and Choco Vanilla Flakes, Combo Pack of 2 Jars [Zero Cholesterol, High Iron and Fibre Chocos Cereal] Jar, 780 g",
    "item_id": "B07SKHQ7DZ",
    "brand": "percy",
    "client": "test"
  },
  {
    "order": 111,
    "price": "Rs 1,399.00",
    "offer": "Rs 3,116.00",
    "page": 3,
    "link": "https://www.amazon.in//Percy-Breakfast-Cereal-Cornflakes-Chocolate/dp/B07SGCQ2CL/",
    "page_count": 48,
    "reviews": 2,
    "ratings": 2.8,
    "image_count": 6,
    "product_name": "Percy Super Saver Breakfast Cereal Combo (Cornflakes, Honey Cornflakes, Choco Flakes, Muesli Fruit&Nut, Chocolate Fills, Fruit Ring), 6 Jumbo Jars, 2.82kg Jar, 2820 g",
    "item_id": "B07SGCQ2CL",
    "brand": "percy",
    "client": "test"
  },
  {
    "order": 112,
    "price": null,
    "offer": "Rs 740.00",
    "page": 3,
    "link": "https://www.amazon.in//Monsoon-Harvest-Toasted-Millet-Cranberry/dp/B07TC5C9Z2/",
    "page_count": 48,
    "reviews": 68,
    "ratings": 4.5,
    "image_count": 6,
    "product_name": "Monsoon Harvest Toasted Millet Muesli, Cranberry & Almond, 1 Kg",
    "item_id": "B07TC5C9Z2",
    "brand": "monsoon harvest",
    "client": "test"
  },
  {
    "order": 113,
    "price": "Rs 240.00",
    "offer": null,
    "page": 3,
    "link": "https://www.amazon.in//Birla-Morton-Corn-Flakes-500g/dp/B01BK7O5L6/",
    "page_count": 48,
    "reviews": 67,
    "ratings": 4.3,
    "image_count": 7,
    "product_name": "Morton Cornflakes Pouch, 500g (Pack of 2)",
    "item_id": "B01BK7O5L6",
    "brand": "morton",
    "client": "test"
  },
  {
    "order": 114,
    "price": null,
    "offer": "Rs 230.00",
    "page": 3,
    "link": "https://www.amazon.in//Monsoon-Harvest-Toasted-Millet-Pistachios/dp/B01N2ALC3J/",
    "page_count": 48,
    "reviews": 116,
    "ratings": 4.3,
    "image_count": 6,
    "product_name": "Monsoon Harvest Toasted Millet Muesli, Fig & Honey with Salted Pistachios, 250 g",
    "item_id": "B01N2ALC3J",
    "brand": "monsoon harvest",
    "client": "test"
  },
  {
    "order": 115,
    "price": "Rs 499.00",
    "offer": "Rs 1,198.00",
    "page": 3,
    "link": "https://www.amazon.in//Swad-Choco-Chocolate-Cereal-Children/dp/B084TN9T5K/",
    "page_count": 48,
    "reviews": 2,
    "ratings": 3.3,
    "image_count": 7,
    "product_name": "Swad Choco Fills & Fruit Rings N Balls, Combo of 2 Jars (Chocolate Milk Cereal Fruit Loop Balls for Children) Jar, 680 g",
    "item_id": "B084TN9T5K",
    "brand": "swad",
    "client": "test"
  },
  {
    "order": 116,
    "price": "Rs 520.00",
    "offer": "Rs 999.00",
    "page": 3,
    "link": "https://www.amazon.in//Percy-Breakfast-Almonds-Raisins-Multigrain/dp/B07SMQZ2KV/",
    "page_count": 48,
    "reviews": 5,
    "ratings": 3.8,
    "image_count": 6,
    "product_name": "Percy Breakfast Cereal, Muesli Fruit and Nut with Oats, Almonds, Raisins, Honey and Dried Fruits, Jumbo Jar [Multigrain, High Fibre] Jar, 800 g",
    "item_id": "B07SMQZ2KV",
    "brand": "percy",
    "client": "test"
  },
  {
    "order": 117,
    "price": "Rs 306.00",
    "offer": "Rs 330.00",
    "page": 3,
    "link": "https://www.amazon.in//Nestle-Koko-Krunch-Breakfast-Cereal/dp/B07Z9LTYMT/",
    "page_count": 48,
    "reviews": 29,
    "ratings": 4.1,
    "image_count": 7,
    "product_name": "Nestle Koko Krunch Breakfast Cereal - Choco Burst, 500 g Box",
    "item_id": "B07Z9LTYMT",
    "brand": "koko krunch",
    "client": "test"
  },
  {
    "order": 118,
    "price": "Rs 275.00",
    "offer": "Rs 500.00",
    "page": 3,
    "link": "https://www.amazon.in//Amazon-Brand-Solimo-chocos-1-2/dp/B0842CV9XT/",
    "page_count": 48,
    "reviews": 75,
    "ratings": 4.2,
    "image_count": 6,
    "product_name": "Amazon Brand - Solimo Choco Flakes, 1.2kg",
    "item_id": "B0842CV9XT",
    "brand": "amazon brand - solimo",
    "client": "test"
  },
  {
    "order": 119,
    "price": "Rs 250.00",
    "offer": null,
    "page": 3,
    "link": "https://www.amazon.in//Jahmz-Cornflakes-1kg/dp/B08RC42D84/",
    "page_count": 48,
    "reviews": 0,
    "ratings": 0,
    "image_count": 2,
    "product_name": "Jahmz - Cornflakes 1kg",
    "item_id": "B08RC42D84",
    "brand": "jahmz",
    "client": "test"
  },
  {
    "order": 120,
    "price": null,
    "offer": "Rs 800.00",
    "page": 3,
    "link": "https://www.amazon.in//True-Elements-Rolled-Gluten-Wholegrain/dp/B07SBMKVRV/",
    "page_count": 48,
    "reviews": 25,
    "ratings": 4.5,
    "image_count": 6,
    "product_name": "True Elements Oats 2kg (1kg * 2) - Gluten Free Rolled Oats, Breakfast Cereal, Whole Oats",
    "item_id": "B07SBMKVRV",
    "brand": "true elements",
    "client": "test"
  },
  {
    "order": 121,
    "price": "Rs 499.00",
    "offer": "Rs 748.00",
    "page": 3,
    "link": "https://www.amazon.in//Swad-Flakes-Classic-Cholesterol-Breakfast/dp/B082NL54MD/",
    "page_count": 48,
    "reviews": 1,
    "ratings": 4.5,
    "image_count": 7,
    "product_name": "Swad Honey Corn Flakes & Classic Corn Flakes, Combo of 2 Jars (Zero Cholesterol, High Fibre Breakfast Cereal) Jar, 570 g",
    "item_id": "B082NL54MD",
    "brand": "swad",
    "client": "test"
  },
  {
    "order": 122,
    "price": "Rs 180.00",
    "offer": null,
    "page": 3,
    "link": "https://www.amazon.in//Nestle-Nesplus-Crunchy-Flakes-Extra/dp/B089P9P5QM/",
    "page_count": 48,
    "reviews": 8,
    "ratings": 4.3,
    "image_count": 7,
    "product_name": "Nestle Nesplus Crunchy Flakes: Corn and Oats, 570g Box (475g + 95g)",
    "item_id": "B089P9P5QM",
    "brand": "nesplus",
    "client": "test"
  },
  {
    "order": 123,
    "price": "Rs 499.00",
    "offer": "Rs 799.00",
    "page": 3,
    "link": "https://www.amazon.in//Swad-Breakfast-Almonds-Multigrain-Cholesterol/dp/B084RF5X8L/",
    "page_count": 48,
    "reviews": 6,
    "ratings": 3,
    "image_count": 7,
    "product_name": "Swad Breakfast Cereal, Muesli Fruit & Nut with Oats, Almonds, Raisins, Honey, Fruits (Multigrain High Fibre, High Protein, Zero Cholesterol Muesli) Jar, 670 g",
    "item_id": "B084RF5X8L",
    "brand": "swad",
    "client": "test"
  },
  {
    "order": 124,
    "price": "Rs 349.00",
    "offer": "Rs 499.00",
    "page": 3,
    "link": "https://www.amazon.in//Percy-Breakfast-Cereal-Chocolate-Multigrain/dp/B07SJF7JQ3/",
    "page_count": 48,
    "reviews": 24,
    "ratings": 3.9,
    "image_count": 5,
    "product_name": "Percy Breakfast Cereal, Chocolate Fills, Multigrain, Jumbo Jar [Multigrain Choco Fills, High Fibre] Jar, 520 g",
    "item_id": "B07SJF7JQ3",
    "brand": "percy",
    "client": "test"
  },
  {
    "order": 125,
    "price": "Rs 320.00",
    "offer": null,
    "page": 3,
    "link": "https://www.amazon.in//Bagrrys-Fruit-Fibre-Muesli-Mixed/dp/B071SD79GJ/",
    "page_count": 48,
    "reviews": 43,
    "ratings": 4.2,
    "image_count": 7,
    "product_name": "Bagrrys Fruit N Fibre Muesli, Mixed Fruit, 500g",
    "item_id": "B071SD79GJ",
    "brand": "bagrry's",
    "client": "test"
  },
  {
    "order": 126,
    "price": "Rs 376.00",
    "offer": "Rs 450.00",
    "page": 3,
    "link": "https://www.amazon.in//Pristine-Beginnings-Organic-Millet-Flakes/dp/B00QTN1KA6/",
    "page_count": 48,
    "reviews": 12,
    "ratings": 4.1,
    "image_count": 7,
    "product_name": "PRISTINE Organics Beginnings Organic Millet Flakes - Ragi, 300g (Pack of 2)",
    "item_id": "B00QTN1KA6",
    "brand": "pristine",
    "client": "test"
  },
  {
    "order": 127,
    "price": "Rs 897.00",
    "offer": "Rs 1,245.00",
    "page": 3,
    "link": "https://www.amazon.in//Percy-Wholegrain-Breakfast-Cornflakes-Vanilla/dp/B07SMR12WM/",
    "page_count": 48,
    "reviews": 0,
    "ratings": 0,
    "image_count": 6,
    "product_name": "Percy Wholegrain Breakfast Combo (Honey Cornflakes, Choco Vanilla Flakes & Choco Flake Cereal), 3 Jumbo Jars, 1.22kg Jar, 1220 g",
    "item_id": "B07SMR12WM",
    "brand": "percy",
    "client": "test"
  },
  {
    "order": 128,
    "price": "Rs 239.00",
    "offer": "Rs 250.00",
    "page": 3,
    "link": "https://www.amazon.in//True-Elements-Muesli-Seeds-Berries/dp/B079SWP5QM/",
    "page_count": 48,
    "reviews": 21,
    "ratings": 4.3,
    "image_count": 7,
    "product_name": "True Elements Seeds and Berries Muesli 400gm - Immunity Booster Breakfast Cereal",
    "item_id": "B079SWP5QM",
    "brand": "true elements",
    "client": "test"
  },
  {
    "order": 129,
    "price": "Rs 315.00",
    "offer": null,
    "page": 3,
    "link": "https://www.amazon.in//Kelloggs-Muesli-21-Fruit-Pouch/dp/B083JMHX1D/",
    "page_count": 48,
    "reviews": 634,
    "ratings": 4.4,
    "image_count": 7,
    "product_name": "Kellogg's Muesli with 21% Fruit and Nut Pouch, 500 g",
    "item_id": "B083JMHX1D",
    "brand": "kellogg's",
    "client": "test"
  },
  {
    "order": 130,
    "price": "Rs 192.00",
    "offer": "Rs 200.00",
    "page": 3,
    "link": "https://www.amazon.in//True-Elements-Gluten-Free-Rolled/dp/B01NCRLSB1/",
    "page_count": 48,
    "reviews": 213,
    "ratings": 4.3,
    "image_count": 6,
    "product_name": "True Elements Oats 500gm - Gluten Free Oats, Fibre Rich Rolled Oats for Breakfast, Healthy Cereal",
    "item_id": "B01NCRLSB1",
    "brand": "true elements",
    "client": "test"
  },
  {
    "order": 131,
    "price": "Rs 499.00",
    "offer": "Rs 798.00",
    "page": 3,
    "link": "https://www.amazon.in//Swad-Multigrain-Chocolate-Breakfast-Cereals/dp/B084SZZMMH/",
    "page_count": 48,
    "reviews": 1,
    "ratings": 3,
    "image_count": 7,
    "product_name": "Swad Choco Fills & Honey Corn Flakes, Combo of 2 Jars (Multigrain Chocolate Fills Breakfast Cereals) Jar, 670 g",
    "item_id": "B084SZZMMH",
    "brand": "swad",
    "client": "test"
  },
  {
    "order": 132,
    "price": "Rs 499.00",
    "offer": "Rs 798.00",
    "page": 3,
    "link": "https://www.amazon.in//Swad-Healthy-Chocolate-Wholegrain-Cereals/dp/B084SZYJYG/",
    "page_count": 48,
    "reviews": 0,
    "ratings": 2.5,
    "image_count": 7,
    "product_name": "Swad Choco Flakes & Choco Fills, Combo of 2 Jars (Healthy Chocolate Chocos Wholegrain Cereals) Jar, 720 g",
    "item_id": "B084SZYJYG",
    "brand": "swad",
    "client": "test"
  },
  {
    "order": 133,
    "price": null,
    "offer": "Rs 350.00",
    "page": 3,
    "link": "https://www.amazon.in//ASAP-Ultimate-Breakfast-Multigrain-Muesli/dp/B08KWH1QHC/",
    "page_count": 48,
    "reviews": 6,
    "ratings": 4.6,
    "image_count": 6,
    "product_name": "ASAP Ultimate Breakfast Multigrain Muesli - BADAMILK (Almond, Honey & 5 Toasted Grains) - Single Pack | 420 g",
    "item_id": "B08KWH1QHC",
    "brand": "asap",
    "client": "test"
  },
  {
    "order": 134,
    "price": "Rs 171.00",
    "offer": "Rs 190.00",
    "page": 3,
    "link": "https://www.amazon.in//Saffola-Masala-Oats-Curry-Pepper/dp/B00UTGC5HG/",
    "page_count": 48,
    "reviews": 54,
    "ratings": 4.2,
    "image_count": 7,
    "product_name": "Saffola Masala Oats, Curry & Pepper, 500g",
    "item_id": "B00UTGC5HG",
    "brand": "saffola",
    "client": "test"
  },
  {
    "order": 135,
    "price": "Rs 598.00",
    "offer": "Rs 998.00",
    "page": 3,
    "link": "https://www.amazon.in//Percy-Chocolate-Chocos-Vanilla-Cereal/dp/B07SNQN99R/",
    "page_count": 48,
    "reviews": 7,
    "ratings": 3.7,
    "image_count": 0,
    "product_name": "Percy Chocolate Fills and Chocos Vanilla Fills, Combo Pack of 2 Jars [High Fibre Chocos Fill and Vanilla Cream Cereal] Jar, 1040 g",
    "item_id": "B07SNQN99R",
    "brand": "percy",
    "client": "test"
  },
  {
    "order": 136,
    "price": "Rs 399.00",
    "offer": "Rs 499.00",
    "page": 3,
    "link": "https://www.amazon.in//Soulful-Bites-Choco-Fills-Combo/dp/B07MW6X4KD/",
    "page_count": 48,
    "reviews": 105,
    "ratings": 4.5,
    "image_count": 5,
    "product_name": "Soulful Ragi Bites with Choco Fills Combo Pack, 1kg",
    "item_id": "B07MW6X4KD",
    "brand": "soulfull",
    "client": "test"
  },
  {
    "order": 137,
    "price": "Rs 540.00",
    "offer": "Rs 600.00",
    "page": 3,
    "link": "https://www.amazon.in//Nutriwish-Quinoa-Flakes-Pouch-1000/dp/B088ZZ56Z1/",
    "page_count": 48,
    "reviews": 0,
    "ratings": 0,
    "image_count": 5,
    "product_name": "Nutriwish Quinoa Flakes Pouch, 1000 g",
    "item_id": "B088ZZ56Z1",
    "brand": "nutriwish",
    "client": "test"
  },
  {
    "order": 138,
    "price": "Rs 319.00",
    "offer": "Rs 325.00",
    "page": 3,
    "link": "https://www.amazon.in//True-Elements-Gluten-Free-Rolled/dp/B01LN5RJD6/",
    "page_count": 48,
    "reviews": 877,
    "ratings": 4.4,
    "image_count": 6,
    "product_name": "True Elements Rolled Oats 1kg - Gluten Free Oats, Oats for Breakfast, Diet Food for Weight Loss",
    "item_id": "B01LN5RJD6",
    "brand": "true elements",
    "client": "test"
  },
  {
    "order": 139,
    "price": "Rs 390.00",
    "offer": null,
    "page": 3,
    "link": "https://www.amazon.in//Jainys-Corn-Flakes-Breakfast-Cereal/dp/B088QFY7G4/",
    "page_count": 48,
    "reviews": 1,
    "ratings": 5,
    "image_count": 3,
    "product_name": "Jainys Corn Flakes, Breakfast Cereal - 3 Pack, 3 x 500 g",
    "item_id": "B088QFY7G4",
    "brand": "jainys",
    "client": "test"
  },
  {
    "order": 140,
    "price": "Rs 190.00",
    "offer": null,
    "page": 3,
    "link": "https://www.amazon.in//Nestle-Koko-Krunch-Breakfast-Cereal/dp/B084G2JCPX/",
    "page_count": 48,
    "reviews": 44,
    "ratings": 4.2,
    "image_count": 7,
    "product_name": "Nestle Koko Krunch Breakfast Cereal - Strawberry Flavour Burst, 250 g Pouch",
    "item_id": "B084G2JCPX",
    "brand": "nestle",
    "client": "test"
  },
  {
    "order": 141,
    "price": "Rs 416.00",
    "offer": "Rs 450.00",
    "page": 3,
    "link": "https://www.amazon.in//True-Elements-Gluten-Steel-1-5kg/dp/B01MRVAYJK/",
    "page_count": 48,
    "reviews": 300,
    "ratings": 4.3,
    "image_count": 6,
    "product_name": "True Elements Steel Cut Oats 1.5 kg - Gluten Free Oats, Oats for Breakfast, Healthy Cereal",
    "item_id": "B01MRVAYJK",
    "brand": "true elements",
    "client": "test"
  },
  {
    "order": 142,
    "price": null,
    "offer": "Rs 595.00",
    "page": 3,
    "link": "https://www.amazon.in//True-Elements-Multigrain-Diet-Muesli/dp/B084STQQ35/",
    "page_count": 48,
    "reviews": 22,
    "ratings": 4.3,
    "image_count": 7,
    "product_name": "True Elements Diet Muesli 1kg - Loaded with Multigrains, Muesli Sugar Free, Cereal for Breakfast, Diet Food for Weight Loss",
    "item_id": "B084STQQ35",
    "brand": "true elements",
    "client": "test"
  },
  {
    "order": 143,
    "price": "Rs 300.00",
    "offer": "Rs 400.00",
    "page": 3,
    "link": "https://www.amazon.in//Green-Foods-Cornflakes-800-Box/dp/B08D9D77TC/",
    "page_count": 48,
    "reviews": 0,
    "ratings": 0,
    "image_count": 6,
    "product_name": "Green Foods Cornflakes 800 gm Box",
    "item_id": "B08D9D77TC",
    "brand": "green foods",
    "client": "test"
  },
  {
    "order": 144,
    "price": "Rs 369.00",
    "offer": "Rs 375.00",
    "page": 3,
    "link": "https://www.amazon.in//Bagrrys-Protein-Muesli-Whey-Almonds/dp/B0752WSWL5/",
    "page_count": 48,
    "reviews": 210,
    "ratings": 4,
    "image_count": 7,
    "product_name": "Bagrry's Protein Muesli with Whey Protein, Almonds and Oats, 500g",
    "item_id": "B0752WSWL5",
    "brand": "bagrry's",
    "client": "test"
  }
] 
        for (let [idx, ds] of  resData.entries())
        {
          self.rows_details.push(ds)
          self.rows_details_full.push(ds)
        }
        self.loader = false
        self.$nextTick(function(){
          self.initDt2()
        })  
      
      }, err => {
        self.loader = false
        console.log(err)
        console.log('err')
      });
    },

    changeCustomDate(){
      if (this.date.startDate)
        this.date.startDate = moment(this.date.startDate).format('YYYY-MM-DD')
    },
    initDt2(){
      let self = this
      $('#myTable2').DataTable({
        initComplete: function () {
          this.api().columns().every( function () {
              var column = this;
              var select = $("<select><option value=''>All</option></select>")
                  .appendTo( $(column.footer()).empty() )
                  .on( 'change', function () {
                      var val = $.fn.dataTable.util.escapeRegex(
                          $(this).val()
                      );    
                      column
                          .search( val ? '^'+val+'$' : '', true, false )
                          .draw();
                  } );
              let arr = []    
              let sortedArr = []
              column.data().unique().sort().each( function ( d, j ) {
                var myVal = $(d).text()
                arr.push(myVal)
              } ); 
                
              sortedArr = arr.sort((a, b) => a.localeCompare(b, navigator.languages[0] || navigator.language, {numeric: true, ignorePunctuation: true}))
              for (let [idx, ds] of sortedArr.entries())
              {
                select.append( "<option value='"+ds+"'>"+ds+"</option>" )
              } 
          } );
        }
      });
    }
  }
}

</script>

<style scoped>

.custom-table
{
  padding: 10px;
  margin:10px;
}

.markitamd
{
  background-color:#ffb9b9!important
}
.markitintel
{
  background-color:#c7e0ff!important;
}
.markitsnap
{
  background-color:#ffd0f5 !important
}
.markitna
{
  background-color:#edf2fb!important
}
.markittek
{
  background-color:#fff0ce!important
}
.space-between-header
{
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #c1c1c1;
  margin-bottom: 10px;
  padding-left: 5px;
  padding-right: 7px;
  padding-bottom: 5px;
}
.space-between-header select
{
  width: fit-content;
  float: right;
  border: 1px solid #c5c5c5;
}
.space-between-header h3 {
  color: #533a79;
    margin-bottom: 0;
    line-height: 31px;
}
.listing-custom
{
    font-size: 18px;
    margin-bottom: 6px;
    text-align: center;
    width: 215px;
    background: #8a87e8;
}
.hint
{
  cursor: pointer;
  background: #f5f5f5;
  color: #080808;
  padding: 3px;
  font-size: 9px;
} 
.amd-legend
{
  text-align: center;
  position: absolute;
  left: 15%;
  right: 15%;
  z-index:999
}
.amd-legend i
{
  
  width: fit-content;
}
.amd-legend span
{
    padding-left: 4px;
    font-size: 12px;
}
.legending
{
  display: inline-block;
  margin-right: 19px;
}
#avgTable th, #avgTable td
{
  border:1px solid #c8ced3!important;
  text-align:left;
  font-size:14px
}
.mycols:first-child
{
 padding-right:2px!important
}
.mycols:last-child
{
 padding-left:2px
}
.mycols:not(:first-child):not(:last-child)
{
 padding-left:2px;
 padding-right:2px
}
</style>
